/**
 * api接口的统一出口
*/
// import Login from '@/api/Login';
import apply from './apply';
import community from './community'
export default {
    // Login,
    apply,
    community
}
